import qs from 'qs';
import { IncomingMessage } from 'http';
import { AppUrl } from '@constants/app';

export const pageUrl = {
  withDomain: (protocol: 'http' | 'https', host: string, page: string = '', query?: object) => {
    const q = query ? `?${qs.stringify(query)}` : '';
    return `${protocol}://${host}${page}${q}`;
  },
  fromReq: (req: IncomingMessage, page: string = '', query?: object) => {
    const q = query ? `?${qs.stringify(query)}` : '';
    const host = req.headers.host;
    const protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http';
    return `${protocol}://${host}${page}${q}`;
  },
  absolute: (page: string = '', query?: object) => {
    const q = query ? `?${qs.stringify(query)}` : '';
    return `${AppUrl}${page}${q}`;
  },
  relative: (page: string = '', query?: object) => {
    const q = query ? `?${qs.stringify(query)}` : '';
    return `${page}${q}`;
  },
};
